const MultiDocumentHandling = () => {
  const features = [
    {
      id: 1,
      image: '/assets/aida/2section-1.svg',
      title: 'Increased Efficiency',
      description: 'Automates time-consuming manual data entry, allowing staff to focus on higher-value tasks.'
    },
    {
      id: 2,
      image: '/assets/aida/2section-2.svg',
      title: 'Enhanced Accuracy',
      description: 'Reduces error associated with manual processing, ensuring high data quality.'
    },
    {
      id: 3,
      image: '/assets/aida/2section-3.svg',
      title: 'Improved Compliance',
      description: 'Maintains data consistency and accuracy, aiding in regulatory compliance efforts.'
    },
    {
      id: 4,
      image: '/assets/aida/2section-4.svg',
      title: 'Cost Savings',
      description: 'Decreases operational costs by minimizing manual labor and streamlining workflows.'
    }
  ];

  return (
    <section className="py-6 md:py-10 lg:py-14 light-blue-bg">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12 lg:mb-14">
          <h2 className="font-bold mb-4 md:mb-5">
            <span className="">Simultaneous </span>
            <span className="secondary-text">Multi-Document</span>
            <span className=""> Handling</span>
          </h2>
          <p className="   max-w-4xl mx-auto px-4 leading-relaxed">
            AiDA is capable of processing multiple documents simultaneously. Easily upload scanned PDFs or images of your 
            documents to AiDA's user interface for automated extraction and initiating the workflow.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-6 lg:gap-7">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="group bg-white rounded overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Image Container */}
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>

              {/* Content Section */}
              <div className="bgblue p-5 md:p-6">
                <h3 className=" text-center   font-bold mb-1 md:mb-1">
                  {feature.title}
                </h3>
                <p className=" text-center text-xs md: opacity-90 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .group {
          animation: fadeInUp 0.6s ease-out forwards;
          opacity: 0;
        }

        @media (prefers-reduced-motion: reduce) {
          .group {
            animation: none;
            opacity: 1;
          }
        }
      `}</style>
    </section>
  );
};

export default MultiDocumentHandling;